var map = {
	"./5000.png": 164,
	"./500green.png": 165,
	"./500pink.png": 166,
	"./500violet.png": 167,
	"./550blue.png": 168,
	"./600blue.png": 169,
	"./600red.png": 170,
	"./650pink.png": 171,
	"./650violet.png": 172,
	"./700blue.png": 173,
	"./700red.png": 174,
	"./700yellow.png": 175,
	"./800orange.png": 176,
	"./800red.png": 177,
	"./900orange.png": 178,
	"./900pink.png": 179,
	"./900yellow.png": 180,
	"./bankrupt.png": 181,
	"./special.png": 182,
	"./spin_now_arrow.png": 183,
	"./spin_now_arrow_mobile.png": 184,
	"./wedge-LITEGAME-TEMPLATE.png": 185,
	"./wheel-LITEGAME-TEMPLATE(old).png": 186,
	"./wheel-LITEGAME-TEMPLATE.png": 187,
	"./wheel.png": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;